import { render, staticRenderFns } from "./ItemOrGroup.vue?vue&type=template&id=4be02bf9&"
import script from "./ItemOrGroup.vue?vue&type=script&lang=js&"
export * from "./ItemOrGroup.vue?vue&type=script&lang=js&"
import style0 from "./ItemOrGroup.vue?vue&type=style&index=0&id=4be02bf9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports